export default __webpack_public_path__ + "static/index-title-news-ko-97e517fc9195cbe3df1a0bfd2eac9bd5.png";